<template>
  <div>
    <Teleport to="#loader-root">
      <div v-if="props.visible" :class="overlayClass">
        <div class="overlay-content border rounded">
          <ProgressSpinner style="height: 2rem" stroke-width="8" fill="transparent" :aria-label="message" />
          <div class="loader-message">{{  props.message  }}</div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import ProgressSpinner from 'primevue/progressspinner';
import { computed } from 'vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
    required: true,
  },
  message: {
    type: String,
    default: 'Loading...'
  },
  showOverlay: {
    type: Boolean,
    default: true
  } 
});

const overlayClass = computed(() => {
  return props.showOverlay ? 'overlay' : 'loader';
});
</script>

<style scoped>
.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 3rem;
  border-radius: 1rem;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.overlay-content {
  display: flex;
  background-color: white;
  align-items: center;
  padding: 1rem;
}

.loader-message {
  margin-left: .25rem; /* Space between spinner and message */
}
</style>